import React from 'react'

import ApplicableAddonRows from '~/components/applicable-addon-rows/'
import { OrderItemPricingDetailRowV3 } from '~/components/order-item-pricing-detail-row'

import { AppliedAddonRows, TotalPriceV3 } from './components'
import { PricingRows } from './order-item-price-summary-v3.styles'

import type { PricingDetail } from '~/components/order-item/order-item.types'
import type { CartAddon, ApplicableCartAddon } from '~/types'

type Props = {
  displayName: string
  displayAgeRange: string
  originalPrice: number
  pricingDetails?: Array<PricingDetail>
  isUpgrade?: boolean
  toggleAddon?: (state: boolean, addonType: string) => void
  isReadOnly: boolean
  totalPrice: number
  forceShowTotalLineItem?: boolean
  allowCollapseTotal?: boolean
  className?: string
  appliedAddons: CartAddon[]
  applicableAddons: ApplicableCartAddon[]
  cartItemInternalId?: string
}

export default function OrderItemPriceSummaryV3({
  displayName,
  displayAgeRange,
  originalPrice,
  pricingDetails,
  isReadOnly,
  isUpgrade,
  toggleAddon,
  totalPrice,
  forceShowTotalLineItem,
  allowCollapseTotal,
  className,
  appliedAddons = [],
  applicableAddons = [],
  cartItemInternalId,
}: Props) {
  const hasExtraPricingDetails = pricingDetails && pricingDetails.length > 0
  const hasAddons = appliedAddons.length > 0
  const totalOnly =
    allowCollapseTotal && isReadOnly && !hasAddons && !hasExtraPricingDetails

  if (totalOnly) {
    return (
      <PricingRows>
        <OrderItemPricingDetailRowV3
          className={className}
          description={`${displayName} ${displayAgeRange}`}
          amount={originalPrice}
          boldAmount
        />
      </PricingRows>
    )
  }

  return (
    <>
      <PricingRows>
        <OrderItemPricingDetailRowV3
          key="product"
          description={`${displayName} ${displayAgeRange}`}
          amount={originalPrice}
        />
        {pricingDetails &&
          pricingDetails.map((pricingDetail, index) => (
            <OrderItemPricingDetailRowV3
              {...pricingDetail}
              key={index}
              withPrefix
              cartItemInternalId={cartItemInternalId}
            />
          ))}
      </PricingRows>
      {isReadOnly ? (
        <AppliedAddonRows appliedAddons={appliedAddons} />
      ) : applicableAddons.length ? (
        <ApplicableAddonRows
          applicableAddons={applicableAddons}
          isUpgrade={isUpgrade}
          toggleAddon={toggleAddon}
        />
      ) : null}
      <TotalPriceV3
        originalPrice={originalPrice}
        totalPrice={totalPrice}
        forceShowTotalLineItem={forceShowTotalLineItem}
      />
    </>
  )
}
